export default "__VITE_ASSET__NlNdvdEs__"